import * as React from "react";
import { useState, useEffect } from "react";
import cargandoCard from "../../components/cargando-card";
import sinAccesoCard from "../../components/sin-acceso-card";


export default function DashboardScreen() {

    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            setCargandoPage(false);
            setTieneAccesoAlModulo(true);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    }

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="m-4">
                    DASHBOARD
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
